var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('markdown-content-link');
import { useLink } from '../../hooks/use-link';
import { CitationReference } from '../entities/citation-reference';
export var CITATION_PATTERN = "\\/citation\\/([^\\/\\)]*)\\/?";
export var MarkdownContentLink = function MarkdownContentLink(props) {
  var _a = props.href,
      href = _a === void 0 ? '' : _a,
      children = props.children,
      rest = __rest(props, ["href", "children"]);

  var matches = href.match(new RegExp(CITATION_PATTERN, "i"));
  var Link = useLink().Link;

  if (matches && matches.length > 1) {
    return React.createElement(CitationReference, {
      id: matches[1]
    }, children);
  }

  return React.createElement(Link, __assign({
    href: href
  }, rest), children);
};
export var MarkdownContentLinkTargetBlank = function MarkdownContentLinkTargetBlank(props) {
  return React.createElement(MarkdownContentLink, __assign({}, props, {
    target: "_blank"
  }), props.children);
};